import { ChatbotMessageRole } from '@fabric/woody-client';
import { AssistantContextType, AssistantContextSubType, ChatbotConversationUserActionType } from './types.js';

const EVERYTHING_CONTEXT = {
  subType: AssistantContextSubType.Everything,
  name: "Everything",
  value: "everything",
  type: AssistantContextType.None
};
const EVERYTHING_CONTEXT_INITIAL_MESSAGE = {
  id: "welcome-message",
  role: ChatbotMessageRole.assistant,
  streaming: false,
  content: "Ask me about any: notes, links, images, audio, video, markdown, PDFs, .txt, .docx, HTML or JSON.",
  rawContent: "Ask me about any: notes, links, images, audio, video, markdown, PDFs, .txt, .docx, HTML or JSON.",
  resourceIds: [],
  resources: [],
  context: EVERYTHING_CONTEXT,
  type: "context-switch-info"
};
const chatbotConversationUserActionNames = {
  [ChatbotConversationUserActionType.SUMMARIZE]: "Summarize",
  [ChatbotConversationUserActionType.LIST_POINTS]: "List points",
  [ChatbotConversationUserActionType.EXPLAIN_LIKE_IM_FIVE]: "Explain like I'm five",
  [ChatbotConversationUserActionType.TWEET]: "Tweet",
  [ChatbotConversationUserActionType.TODO_LIST]: "To-do list",
  [ChatbotConversationUserActionType.EMAIL]: "Email",
  [ChatbotConversationUserActionType.CLEANUP]: "Tidy up formatting"
};
const chatbotConversationUserActionDummyTexts = {
  [ChatbotConversationUserActionType.SUMMARIZE]: ({ isSelection, resourceGenericName }) => {
    if (isSelection) return "Give me a summary for the current selection";
    if (resourceGenericName) return `Give me a summary for the ${resourceGenericName}'s content`;
    return `Give me a summary for this item's content`;
  },
  [ChatbotConversationUserActionType.LIST_POINTS]: ({ isSelection, resourceGenericName }) => {
    if (isSelection) return "Give me a list of points for the current selection";
    if (resourceGenericName) return `Give me a list of points for the ${resourceGenericName}'s content`;
    return `Give me a list of points for this item's content`;
  },
  [ChatbotConversationUserActionType.EXPLAIN_LIKE_IM_FIVE]: ({ isSelection, resourceGenericName }) => {
    if (isSelection) return "Explain the current selection like I'm five";
    if (resourceGenericName) return `Explain this ${resourceGenericName}'s content like I'm five`;
    return `Explain this item's content like I'm five `;
  },
  [ChatbotConversationUserActionType.TWEET]: ({ isSelection, resourceGenericName }) => {
    if (isSelection) return "Write a catchy tweet for the current selection";
    if (resourceGenericName) return `Write a catchy tweet for the ${resourceGenericName}'s content`;
    return `Write a catchy tweet for this item's content`;
  },
  [ChatbotConversationUserActionType.TODO_LIST]: ({ isSelection, resourceGenericName }) => {
    if (isSelection) return "Create a to-do list for the current selection";
    if (resourceGenericName) return `Create a to-do list for the ${resourceGenericName}'s content`;
    return `Create a to-do list for this item's content`;
  },
  [ChatbotConversationUserActionType.EMAIL]: ({ isSelection, resourceGenericName }) => {
    if (isSelection) return "Write an email for the current selection";
    if (resourceGenericName) return `Write an email for the ${resourceGenericName}'s content`;
    return `Write an email for this item's content`;
  },
  [ChatbotConversationUserActionType.CLEANUP]: ({ isSelection, resourceGenericName }) => {
    if (isSelection) return "Clean up the content of the current selection";
    if (resourceGenericName) return `Clean up the content of the ${resourceGenericName}`;
    return `Clean up the content of this item`;
  }
};
const ChatbotMessageActionsMinChars = 280;

export { ChatbotMessageActionsMinChars, EVERYTHING_CONTEXT, EVERYTHING_CONTEXT_INITIAL_MESSAGE, chatbotConversationUserActionDummyTexts, chatbotConversationUserActionNames };
//# sourceMappingURL=constants.js.map
